import React, { useContext, useEffect, useState } from 'react';
import { H2, H3 } from '@zooplus/ui-components';
import { useTranslation } from 'react-i18next';
import LivechatInfoSection from '../LivechatInfoSection';
import { ExperimentationContext } from '../context/ExperimentationContext';

const FormHeader: React.FC = () => {
  const { t } = useTranslation();
  const [livechatEnabled, setLivechatEnabled] = useState<boolean>(false);
  const experimentation = useContext(ExperimentationContext);

  useEffect(() => {
    return setLivechatEnabled(experimentation.isLivechatIconDisplayed());
  }, [experimentation]);

  return (
    <header>
      <div className="contactForm__container formHeader__align-center">
        <H2>{t('header.primary_message')}</H2>
        <H3>{t('header.secondary_message')}</H3>
      </div>
      {livechatEnabled && <LivechatInfoSection />}
    </header>
  );
};
export default FormHeader;
